import { ref, onMounted, watch, nextTick, computed } from 'vue'
import { getTableRowsHeight, setTableRowsHeight } from '@/utils/store-table-size'
export default function useRows (data, leftBodyRef, mainBodyRef, tableId) {
  const rowsHeight = ref({})
  const resetRowsHeight = () => {
    if (!data.value.length) {
      return
    }
    const mainElements = mainBodyRef.value.children
    const leftElements = leftBodyRef.value.children
    const count = Object.keys(rowsHeight.value).length
    const leftCount = leftElements.length
    const storedHeight = JSON.parse(getTableRowsHeight(tableId.value) || '{}')
    Object.keys(rowsHeight.value).forEach((val, index, arr) => {
      rowsHeight.value[val] = storedHeight[val] || Math.max(mainElements[index]?.offsetHeight || 0, leftElements[leftCount - count + index]?.offsetHeight || 0)
    })
    setTableRowsHeight(tableId.value, JSON.stringify(rowsHeight.value))
  }

  onMounted(() => {
    resetRowsHeight()
  })
  watch(() => data.value.length, async () => {
    rowsHeight.value = {}
    data.value.forEach(item => {
      rowsHeight.value[item.rowId] = undefined
    })
    await nextTick()
    resetRowsHeight()
  })

  const gridTemplateRows = computed(() => data.value.map(item => rowsHeight.value[item.rowId]).map(item => item ? `${item}px` : 'max-content').join(' '))

  return {
    rowsHeight,
    gridTemplateRows
  }
}
